export function readLabelPinEntry(location: Pick<Location, "pathname" | "hash" | "search">, history: Pick<History, "replaceState" | "state">) {
  const active = location.pathname === "/etiket";
  if (!active) return { active, setupToken: null };
  const token = new URLSearchParams(location.hash.replace(/^#/u, "")).get("pin-setup");
  if (token !== null) history.replaceState(history.state, "", location.pathname + location.search);
  return { active, setupToken: token && /^[A-Za-z0-9_-]{43,128}$/u.test(token) ? token : null };
}
